module.exports = __webpack_public_path__ + "img/1551493574.afc1c93e.jpg";